import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Loader2 } from 'lucide-react'
import { subscriptionApi } from '@/api/subscription'

/**
 * 구독이 필요한 라우트를 보호하는 컴포넌트
 * 활성 구독이 없으면 구독 플랜 페이지로 리다이렉트
 */
export function SubscriptionRoute() {
  const location = useLocation()

  const { data, isLoading, error } = useQuery({
    queryKey: ['subscription-check'],
    queryFn: subscriptionApi.checkMySubscription,
    staleTime: 60 * 1000, // 1분
    retry: 1,
  })

  // 로딩 중
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <Loader2 className="w-10 h-10 text-primary-600 animate-spin mb-4" />
        <p className="text-gray-600">구독 상태를 확인하는 중...</p>
      </div>
    )
  }

  // 에러 발생 시 (API 실패) - 일단 통과시킴 (또는 구독 페이지로)
  if (error) {
    console.error('Subscription check error:', error)
    // API 에러 시에도 일단 구독 페이지로 보내서 선택하게 함
    return <Navigate to="/subscription/plans" state={{ from: location }} replace />
  }

  // 활성 구독이 없으면 구독 플랜 페이지로 리다이렉트
  if (data && !data.hasActiveSubscription) {
    return <Navigate to="/subscription/plans" state={{ from: location }} replace />
  }

  return <Outlet />
}





















